import React from "react";
import { useRecordContext } from "react-admin";
import get from "lodash/get";
import Typography from "@mui/material/Typography";
import { grey as Grey } from "@mui/material/colors";

type Props = {
  amendSource: string;
  source: string;
  record?: any;
  label?: string;
  sortable?: boolean;
  formatter?: (record: any) => any;
  choices?: Record<string, string>[];
};

const commonStyles = {
  typography: {
    textDecoration: "line-through",
    color: Grey["600"],
  },
};

export const DealAmendField = (props: Props) => {
  const record = useRecordContext();
  const { amendSource, source, formatter, choices } = props;

  if (!record) {
    return null;
  }

  const dealData = get(record, source);
  const dealDataChoice = choices?.find((choice) => choice.id === dealData);
  const amendData = get(record.amend, amendSource);
  const amendDataChoice = choices?.find((choice) => choice.id === amendData);
  if (dealData === undefined || amendData === undefined) {
    return null;
  }
  const formattedDealData = formatter ? formatter(record) : choices ? dealDataChoice?.name : dealData;
  const formattedAmendData = formatter ? formatter(record.amend) : choices ? amendDataChoice?.name : amendData;

  return (
    <>
      <Typography key={2} variant="body2">
        {formattedAmendData}（最終）
      </Typography>
      <Typography key={1} variant="body2" sx={commonStyles.typography}>
        {formattedDealData}（契約時）
      </Typography>
    </>
  );
};
